import { isEnabledPagePath, isUnlistedPagePath } from "./page-paths";
import type { ExperienceConfig } from "./experiences";

/** Directory cards use discovery fields only. Never copy an authored document into a feed. */
export function pageDirectoryItems(
  pages: readonly {
    id: string;
    path: string;
    title: string;
    description: string;
    access: "public" | "members";
    hideFromSearch: boolean;
  }[],
  options: {
    pathPrefix?: string;
    current: string;
    experiences: readonly Pick<ExperienceConfig, "kind" | "enabled">[];
  },
) {
  return pages
    .filter(
      (page) =>
        page.path !== options.current &&
        !page.hideFromSearch &&
        !isUnlistedPagePath(page.path) &&
        isEnabledPagePath(page.path, options.experiences) &&
        (!options.pathPrefix || page.path.startsWith(`${options.pathPrefix}/`)),
    )
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((page) => ({
      id: page.id,
      title: page.title,
      summary: page.description,
      image: null,
      url: page.path,
      locked: page.access === "members",
      access: page.access === "members" ? ("paid" as const) : ("free" as const),
    }));
}

export function directorySearchKey(value: string) {
  return value
    .normalize("NFKD")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

export function directoryMatches(
  item: { title: string; summary: string; url: string },
  query: string,
) {
  const fields = [item.title, item.summary, item.url].map(directorySearchKey);
  return query
    .trim()
    .split(/\s+/)
    .map(directorySearchKey)
    .filter(Boolean)
    .every((term) => fields.some((field) => field.includes(term)));
}
